import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './components/MainPage';
import About from './components/About';
import Leadership from './components/Leadership';
import Contact from './components/Contact';
import KYCVernacularLanguage from './components/KYCVernacularLanguage';
import ClientBankDetails from './components/ClientBankDetails';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdvisoryForInvestors from './components/AdvisoryForInvestors';
import RiskDisclosureOnDerivatives from './components/RiskDisclosureOnDerivatives';
import AdvisoryOnImpersonation from './components/AdvisoryOnImpersonation';
import InvestorComplaints from './components/InvestorComplaints';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/kyc-vernacular-language" element={<KYCVernacularLanguage />} />
          <Route path="/client-bank-details" element={<ClientBankDetails />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/advisory-for-investors" element={<AdvisoryForInvestors />} />
          <Route path="/risk-disclosure-on-derivatives" element={<RiskDisclosureOnDerivatives />} />
          <Route path="/advisory-on-impersonation" element={<AdvisoryOnImpersonation />} />
          <Route path="/investor-complaints" element={<InvestorComplaints />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;